module.exports = __webpack_public_path__ + "static/media/manual.e3582344.svg";